export default {
    account_change_status_title: "Cambiar el estado",
    account_change_the_status_has_been_changed: "El estado ha sido modificado",
    account_change_it_was_not_possible_to_change_the_status: "No fue posible cambiar el estado",
    account_change_status_label: "Estado",
    account_change_label: "Cambiar",
    account_change_same_status: "La cuenta tiene actualmente el mismo estado",
    account_change_status_programmed: "Se ha programado el cambio de estado"
};